export default "__VITE_ASSET__wBQB9zCn__";